module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "p-layout-breadcrumb"
  }, [_c('el-row', {
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 3
    }
  }, [_c('h3', [_vm._v("评论列表")])])], 1)], 1), _vm._v(" "), _c('el-form', {
    ref: "formInline",
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号",
      "prop": "orderNo"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "订单号"
    },
    model: {
      value: (_vm.formInline.orderNo),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "orderNo", $$v)
      },
      expression: "formInline.orderNo"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号",
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "手机号"
    },
    model: {
      value: (_vm.formInline.username),
      callback: function($$v) {
        _vm.$set(_vm.formInline, "username", $$v)
      },
      expression: "formInline.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.Search
    }
  }, [_vm._v("查询")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('formInline')
      }
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    attrs: {
      "data": _vm.fetchList,
      "element-loading-text": "拼命加载中",
      "default-sort": {
        prop: 'status'
      }
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "label": "ID"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "orderInfo.orderNo",
      "label": "订单号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userManage.nickName",
      "label": "用户昵称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "userInfo.username",
      "label": "手机号"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "productObj.name",
      "label": "设备名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "content",
      "label": "评价内容"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "prop": "created",
      "label": "评价时间"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return (_vm.row.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.row.created).getFullYear() + '-' + (new Date(_vm.row.created).getMonth() + 1) + '-' + new Date(_vm.row.created).getDate() + ' ' + new Date(_vm.row.created).getHours() + ':' + new Date(_vm.row.created).getMinutes() + ':' + new Date(_vm.row.created).getSeconds()) + " ")]) : _vm._e()
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "label": "状态",
      "sortable": "",
      "prop": "status"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [(_vm.row.status === 1) ? _c('span', [_vm._v("审核通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 2) ? _c('span', [_vm._v("审核不通过")]) : _vm._e(), _vm._v(" "), (_vm.row.status === 0 || _vm.row.status === null) ? _c('span', [_vm._v("待审核")]) : _vm._e()])
        
      },
      staticRenderFns: []
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "context": _vm._self,
      "width": "200",
      "label": "操作"
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('span', [(_vm.row.status === 0 || _vm.row.status === null) ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleCheck(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("审核")]) : _vm._e(), _vm._v(" "), _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleView(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("查看")]), _vm._v(" "), (_vm.Role === '1') ? _c('el-button', {
            attrs: {
              "type": "text",
              "size": "small"
            },
            on: {
              "click": function($event) {
                return _vm.handleDelete(_vm.$index, _vm.row)
              }
            }
          }, [_vm._v("删除")]) : _vm._e()], 1)
        
      },
      staticRenderFns: []
    }
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": 20,
      "layout": "total, prev, pager, next",
      "total": _vm.totalNum
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      },
      "update:current-page": function($event) {
        _vm.currentPage = $event
      }
    }
  }), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看评论详情",
      "visible": _vm.dialogFormVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号：",
      "label-width": "150px"
    }
  }, [(_vm.form.orderInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.orderInfo.orderNo))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [(_vm.form.userInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.userInfo.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称：",
      "label-width": "150px"
    }
  }, [(_vm.form.productObj) ? _c('span', [_vm._v(_vm._s(_vm.form.productObj.name))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价时间：",
      "label-width": "150px"
    }
  }, [(_vm.form.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价内容：",
      "label-width": "150px"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.form.content))]), _vm._v(" "), (_vm.form.photo && _vm.form.photo.length) ? _c('div', {
    staticClass: "img-item"
  }, _vm._l((_vm.form.photo), function(item) {
    return _c('img', {
      key: item,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价分数：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.grade) + " "), _c('small', [_vm._v("（最高5分，最低1分）")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.dialogFormVisible = false
      }
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "审核评论详情",
      "visible": _vm.dialogCheckVisible,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogCheckVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.form
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单号：",
      "label-width": "150px"
    }
  }, [(_vm.form.orderInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.orderInfo.orderNo))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户昵称：",
      "label-width": "150px"
    }
  }, [(_vm.form.userManage) ? _c('span', [_vm._v(_vm._s(_vm.form.userManage.nickName))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号：",
      "label-width": "150px"
    }
  }, [(_vm.form.userInfo) ? _c('span', [_vm._v(_vm._s(_vm.form.userInfo.username))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "设备名称：",
      "label-width": "150px"
    }
  }, [(_vm.form.productObj) ? _c('span', [_vm._v(_vm._s(_vm.form.productObj.name))]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价时间：",
      "label-width": "150px"
    }
  }, [(_vm.form.created) ? _c('span', [_vm._v(_vm._s(new Date(_vm.form.created).getFullYear() + '-' + (new Date(_vm.form.created).getMonth() + 1) + '-' + new Date(_vm.form.created).getDate() + ' ' + new Date(_vm.form.created).getHours() + ':' + new Date(_vm.form.created).getMinutes() + ':' + new Date(_vm.form.created).getSeconds()) + " ")]) : _vm._e()]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价内容：",
      "label-width": "150px"
    }
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.form.content))]), _vm._v(" "), (_vm.form.photo && _vm.form.photo.length) ? _c('div', {
    staticClass: "img-item"
  }, _vm._l((_vm.form.photo), function(item) {
    return _c('img', {
      key: item,
      attrs: {
        "src": item,
        "alt": ""
      }
    })
  }), 0) : _vm._e()])]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "评价分数：",
      "label-width": "150px"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.form.grade) + " "), _c('small', [_vm._v("（最高5分，最低1分）")])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handlePass
    }
  }, [_vm._v("审核通过")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "danger"
    },
    on: {
      "click": _vm.handleNo
    }
  }, [_vm._v("审核不通过")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d69831b4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/order/CommentList.vue
// module id = 755
// module chunks = 1